(function () {
const $5f0936c8b0990a8b$var$prefix = "[800js] \uD83D\uDE80";
// @todo: all log entries get pushed into an array that can be pushed to backend for telemetry
function $5f0936c8b0990a8b$export$1c9f709888824e05(...args) {
    if (!$5f0936c8b0990a8b$export$931813d4b9c88e2a()) return;
    console.debug(...args);
}
function $5f0936c8b0990a8b$export$a80b3bd66acc52ff(...args) {
    if (!$5f0936c8b0990a8b$export$931813d4b9c88e2a()) return;
    console.info(...args);
}
function $5f0936c8b0990a8b$export$c106dd0671a0fc2d(...args) {
    if (!$5f0936c8b0990a8b$export$931813d4b9c88e2a()) return;
    console.warn(...args);
}
function $5f0936c8b0990a8b$export$a3bc9b8ed74fc(...args) {
    if (!$5f0936c8b0990a8b$export$931813d4b9c88e2a()) return;
    console.error(...args);
}
function $5f0936c8b0990a8b$export$931813d4b9c88e2a() {
    return document?.cookie?.indexOf('_800dbg') !== -1 || window?._800js?.debug === true;
}


const $d0b7dfbc17617186$export$c75e4443b477ae4 = /(?:(?:\+?([1-9]|[0-9][0-9]|[0-9][0-9][0-9])\s*(?:[.\-–—]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([0-9][1-9]|[0-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.\-–—]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.\-–—]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?/g;
const $d0b7dfbc17617186$export$7f13c8d775287840 = (node)=>{
    if (node.innerHTML?.includes('tel:')) return true;
    if (node.href?.includes('tel:')) return true;
    if (node.textContent?.trim() === '') return false;
    if (!node.textContent?.match(/\d/)) return false;
    // if (! node.textContent?.match(phoneNumberRegex)) {
    //     return false;
    // }
    return true;
};
const $d0b7dfbc17617186$export$9e32ceef92e19c15 = (node)=>{
    const nodes = [];
    // -----------------------------
    // #1: Process the current node
    // -----------------------------
    if (node.parentElement instanceof HTMLScriptElement) return nodes;
    if (node.parentElement?.closest('.no-swap')) return nodes;
    if (node.nodeType === Node.TEXT_NODE) return [
        node
    ];
    if (node instanceof HTMLAnchorElement) nodes.push(node);
    // -----------------------------
    // #2: Process child nodes
    // -----------------------------
    if (!$d0b7dfbc17617186$export$7f13c8d775287840(node)) return nodes;
    // Check if this node's combined text might contain a phone number split across children
    // e.g., <p><strong>800</strong>-<strong>888</strong>-<strong>0001</strong></p>
    const textContent = node.textContent || '';
    // Test if combined text contains a phone number
    $d0b7dfbc17617186$export$c75e4443b477ae4.lastIndex = 0;
    const hasPhoneNumberPattern = $d0b7dfbc17617186$export$c75e4443b477ae4.test(textContent);
    // If the combined text contains a phone number and we have multiple children with digits,
    // check if any individual child contains a complete phone number
    if (hasPhoneNumberPattern && node.childNodes.length > 1) {
        const childrenWithDigits = Array.from(node.childNodes).filter((child)=>child.textContent?.match(/\d/));
        if (childrenWithDigits.length > 1) {
            // Check if any child contains a complete phone number
            const hasChildWithCompleteNumber = childrenWithDigits.some((child)=>{
                $d0b7dfbc17617186$export$c75e4443b477ae4.lastIndex = 0;
                return $d0b7dfbc17617186$export$c75e4443b477ae4.test(child.textContent || '');
            });
            // Only return parent if no child has a complete phone number (i.e., number is truly split)
            if (!hasChildWithCompleteNumber) return [
                node
            ];
        }
    }
    for(let i = 0; i < node.childNodes.length; i++){
        const swappableChildNodes = $d0b7dfbc17617186$export$9e32ceef92e19c15(node.childNodes.item(i));
        nodes.push(...swappableChildNodes);
    }
    return nodes.filter((n)=>n.nodeValue !== null || n.href !== null);
};
const $d0b7dfbc17617186$var$getUnprocessedNodeFilter = (cache)=>{
    return function(node) {
        // debug('Swapper.observeNode', node);
        // #1: Check if node is already in cache
        if (cache.has(node)) // debug('Swapper.observeNode: node already in cache', node);
        return false;
        // #2: Add node to cache
        // debug('Swapper.observeNode: observed node first time', node);
        cache.add(node);
        return true;
    };
};
const $d0b7dfbc17617186$var$logMutationText = (node)=>{
    (0, $5f0936c8b0990a8b$export$1c9f709888824e05)('[mutation] Detected text node:', node.textContent);
    return node;
};
const $d0b7dfbc17617186$export$ca12be886f5e4fed = (callback)=>{
    const cache = new WeakSet();
    const nodeFilter = $d0b7dfbc17617186$var$getUnprocessedNodeFilter(cache);
    const observer = new MutationObserver((mutations)=>{
        (0, $5f0936c8b0990a8b$export$1c9f709888824e05)("Observed mutation");
        mutations.filter((mutation)=>mutation.addedNodes.length !== 0).forEach((mutation)=>{
            Array.from(mutation.addedNodes).map((node)=>{
                $d0b7dfbc17617186$export$9e32ceef92e19c15(node).filter(nodeFilter).forEach(callback);
            });
        });
    });
    function onDomContentLoaded() {
        // Perform walk on domcontentloaded (todo: DRY)
        (0, $5f0936c8b0990a8b$export$1c9f709888824e05)('DOMContentLoaded: performing walk');
        const nodes = $d0b7dfbc17617186$export$9e32ceef92e19c15(document.body);
        (0, $5f0936c8b0990a8b$export$1c9f709888824e05)('DOMContentLoaded: walk discovered', nodes.length, 'nodes');
        nodes.filter(nodeFilter).forEach(callback);
    }
    document.addEventListener('DOMContentLoaded', onDomContentLoaded);
    (0, $5f0936c8b0990a8b$export$1c9f709888824e05)('Document Ready State:', document.readyState);
    if (document.readyState === 'complete' || document.readyState === 'interactive') $d0b7dfbc17617186$export$9e32ceef92e19c15(document.body).filter(nodeFilter).forEach(callback);
    (0, $5f0936c8b0990a8b$export$1c9f709888824e05)('observing changes');
    observer.observe(document, {
        childList: true,
        subtree: true,
        characterData: true
    });
    // stop the watcher.
    return ()=>{
        document.removeEventListener('DOMContentLoaded', onDomContentLoaded);
        observer.disconnect();
    };
};


var $5ceb1485e1c336c7$exports = {};
'use strict';
$5ceb1485e1c336c7$exports = $5ceb1485e1c336c7$var$isMobile;
$5ceb1485e1c336c7$exports.isMobile = $5ceb1485e1c336c7$var$isMobile;
$5ceb1485e1c336c7$exports.default = $5ceb1485e1c336c7$var$isMobile;
const $5ceb1485e1c336c7$var$mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const $5ceb1485e1c336c7$var$notMobileRE = /CrOS/;
const $5ceb1485e1c336c7$var$tabletRE = /android|ipad|playbook|silk/i;
function $5ceb1485e1c336c7$var$isMobile(opts) {
    if (!opts) opts = {};
    let ua = opts.ua;
    if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
    if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') ua = ua.headers['user-agent'];
    if (typeof ua !== 'string') return false;
    let result = $5ceb1485e1c336c7$var$mobileRE.test(ua) && !$5ceb1485e1c336c7$var$notMobileRE.test(ua) || !!opts.tablet && $5ceb1485e1c336c7$var$tabletRE.test(ua);
    if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf('Macintosh') !== -1 && ua.indexOf('Safari') !== -1) result = true;
    return result;
}


let $a6af0f4fc1a7d864$var$lastEventCount = undefined;
let $a6af0f4fc1a7d864$var$lastDataLayerCaptured = {};
const $a6af0f4fc1a7d864$var$removeEmptyValues = (obj)=>{
    return Object.fromEntries(Object.entries(obj).filter(([_, v])=>v !== null && v !== ''));
};
const $a6af0f4fc1a7d864$export$6411f84b48e7973c = (items)=>{
    if (items.length === 0) return {};
    if (items.length === 1) return $a6af0f4fc1a7d864$var$removeEmptyValues({
        ...items[0]
    });
    const firstItem = {
        ...items[0]
    };
    const reduced = items.slice(1).reduce((acc, item)=>{
        for(const key in item)if (acc[key] !== item[key]) // Null when there are conflicting values.
        acc[key] = null;
        for(const key in acc)if (item[key] === undefined) // Null when there are conflicting values.
        acc[key] = null;
        return acc;
    }, firstItem);
    return $a6af0f4fc1a7d864$var$removeEmptyValues(reduced);
};
const $a6af0f4fc1a7d864$var$isEqual = (a, b)=>{
    return Object.keys(a).every((key)=>a[key] === b[key]) && Object.keys(b).every((key)=>a[key] === b[key]);
};
const $a6af0f4fc1a7d864$export$422e45e5b4ae11c3 = ()=>{
    if (!window.asc_datalayer) return {};
    let capture;
    capture = $a6af0f4fc1a7d864$export$6411f84b48e7973c(window.asc_datalayer.items || []);
    capture.page_type = window.asc_datalayer.page_type;
    capture.affiliation = window.asc_datalayer.affiliation;
    // --------------------------------------------------------------
    // These fields could be available, but not currently used by us
    // --------------------------------------------------------------
    //   capture.currency = window.asc_datalayer.currency;
    //   capture.language = window.asc_datalayer.language;
    //   capture.oem_code = window.asc_datalayer.oem_code;
    //   capture.oem_brand = window.asc_datalayer.oem_brand;
    //   capture.store_name = window.asc_datalayer.store_name;
    return capture;
};
const $a6af0f4fc1a7d864$var$captureAscDataLayer = ()=>{
    if (!window.asc_datalayer) return;
    const capture = $a6af0f4fc1a7d864$export$422e45e5b4ae11c3();
    if ($a6af0f4fc1a7d864$var$isEqual(capture, $a6af0f4fc1a7d864$var$lastDataLayerCaptured)) return;
    $a6af0f4fc1a7d864$var$lastDataLayerCaptured = capture;
    window.dispatchEvent(new CustomEvent('800dni.asc-datalayer', {
        detail: {
            dataLayer: capture
        }
    }));
};
const $a6af0f4fc1a7d864$var$checkForNewAscEvents = ()=>{
    const eventCount = window.asc_datalayer?.events?.length || 0;
    if (eventCount === $a6af0f4fc1a7d864$var$lastEventCount) return;
    // We've had new events since the last data layer capture
    // so it's possible the other data in data_layer has changed.
    $a6af0f4fc1a7d864$var$lastEventCount = eventCount;
    $a6af0f4fc1a7d864$var$captureAscDataLayer();
};
const $a6af0f4fc1a7d864$export$1ef0a386b5db328d = ()=>{
    setTimeout(()=>{
        $a6af0f4fc1a7d864$var$captureAscDataLayer();
        $a6af0f4fc1a7d864$var$lastEventCount = window.asc_datalayer?.events?.length || 0;
        setInterval($a6af0f4fc1a7d864$var$checkForNewAscEvents, 500);
    }, 500);
};


let $f666fece0d4e83e8$var$eventFired = false;
const $f666fece0d4e83e8$var$CTC_LISTENER_ADDED_ATTRIBUTE = 'data-800-ctc-listener';
const $f666fece0d4e83e8$var$CTC_WRAPPER_ATTRIBUTE = 'data-800-ctc-wrapper';
const $f666fece0d4e83e8$var$addClickListenerToNode = (node, numberE164)=>{
    if (node.hasAttribute($f666fece0d4e83e8$var$CTC_LISTENER_ADDED_ATTRIBUTE)) return;
    node.toggleAttribute($f666fece0d4e83e8$var$CTC_LISTENER_ADDED_ATTRIBUTE, true);
    const fireClickToCallEvent = ()=>{
        if ($f666fece0d4e83e8$var$eventFired) return;
        // We could have an event listener bound to multiple elements 
        // such that the event fires multiple times for a single click.
        // We do not want to mess with event propagation as we 
        // might break something outside of our control.
        // This code guards against excessive events firing.
        setTimeout(()=>$f666fece0d4e83e8$var$eventFired = false, 5000);
        $f666fece0d4e83e8$var$eventFired = true;
        // Firefox sometimes aborts the request with NS_BINDING_ABORTED error. 
        // By using a timeout, this doesn't happen anymore.
        setTimeout(()=>{
            window.dispatchEvent(new CustomEvent('800dni.asc-event', {
                detail: {
                    ascEventName: 'asc_click_to_call',
                    ascEventData: {
                        ...(0, $a6af0f4fc1a7d864$export$422e45e5b4ae11c3)(),
                        comm_phone_number: numberE164
                    }
                }
            }));
        });
    };
    // Many devices have the option to call after selecting text.
    //   (e.g. with a long press on the phone number)
    // We should treat that as a click to call, as that's probably the intention.
    node.addEventListener('selectstart', fireClickToCallEvent);
    node.addEventListener('click', fireClickToCallEvent);
};
const $f666fece0d4e83e8$var$addClickTracking = (node, text, numberE164)=>{
    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'A' && String(node.getAttribute('href')).substring(4) === text) {
        // We're looking at an anchor tag, so anything inside is part of the C2C. 
        $f666fece0d4e83e8$var$addClickListenerToNode(node, numberE164);
        return;
    }
    // Node is a has a single child text node with nothing but the text
    if (node.childNodes.length === 1 && node.childNodes[0].nodeType === Node.TEXT_NODE) {
        const nodeText = node.childNodes[0].nodeValue || '';
        if (nodeText === text || nodeText.trim() === text) {
            $f666fece0d4e83e8$var$addClickListenerToNode(node, numberE164);
            return;
        }
    }
    // Node has multiple child nodes or the text is not the only thing in the node
    for(let i = 0; i < node.childNodes.length; i++){
        const childNode = node.childNodes[i];
        if (childNode.nodeType === Node.ELEMENT_NODE) {
            if (childNode.hasAttribute($f666fece0d4e83e8$var$CTC_WRAPPER_ATTRIBUTE) || childNode.hasAttribute($f666fece0d4e83e8$var$CTC_LISTENER_ADDED_ATTRIBUTE)) continue;
            $f666fece0d4e83e8$var$addClickTracking(childNode, text, numberE164);
        }
        if (childNode.nodeValue === null || childNode.parentNode === null || childNode.nodeType !== Node.TEXT_NODE) continue;
        if (!childNode.nodeValue?.includes(text)) continue;
        const parts = childNode.nodeValue.split(text);
        const parentNode = childNode.parentNode;
        for(let i = 0; i < parts.length; i++){
            // Insert any text that is not part of the phone number
            parentNode.insertBefore(document.createTextNode(parts[i]), childNode);
            if (i < parts.length - 1) {
                // Insert the phone number, wrapped in a clickable span
                const wrapperSpan = document.createElement('span');
                // This should help prevent any CSS applying to this element.
                wrapperSpan.setAttribute('style', 'all: unset !important');
                wrapperSpan.toggleAttribute($f666fece0d4e83e8$var$CTC_WRAPPER_ATTRIBUTE, true);
                wrapperSpan.append(document.createTextNode(text));
                parentNode.insertBefore(wrapperSpan, childNode);
                $f666fece0d4e83e8$var$addClickListenerToNode(wrapperSpan, numberE164);
            }
        }
        // Keep a reference to the old parent node 
        // as we may see the same child again if it 
        // contained multiple phone numbers.
        childNode.danglingChildParentNode = parentNode;
        parentNode.removeChild(childNode);
    }
};
const $f666fece0d4e83e8$export$c0f3019f7e74c5cf = (e)=>{
    const { replacement: replacement, replacementE164: replacementE164, node: node } = e.detail;
    if ('danglingChildParentNode' in node) {
        // We've processed this node before, and then removed it from the DOM 
        // as part of the process that adds a wrapper span. 
        $f666fece0d4e83e8$var$addClickTracking(node.danglingChildParentNode, replacement, replacementE164);
        return;
    }
    if (node.parentNode !== null && node.parentNode.nodeType === Node.ELEMENT_NODE) $f666fece0d4e83e8$var$addClickTracking(node.parentNode, replacement, replacementE164);
};
const $f666fece0d4e83e8$export$76b46e2f8835d97 = ()=>{
    // Only run on mobile/tablet devices
    if (!(0, $5ceb1485e1c336c7$exports.isMobile)({
        tablet: true
    })) return;
    window.addEventListener('800dni.swap', $f666fece0d4e83e8$export$c0f3019f7e74c5cf);
};



function $8ed3c7b9a73a82be$export$82112e1a17c2a69b(number) {
    if (number.startsWith('+1')) return number;
    if (number.startsWith('1')) return '+' + number;
    return '+1' + number;
}
function $8ed3c7b9a73a82be$export$277d7fa50e12435e(targetFormat, phoneNumber) {
    const replacementChars = phoneNumber.split('');
    const originalChars = targetFormat.split('').filter((c)=>c !== "\n");
    if (targetFormat.match(/([a-zA-Z])/)) return $8ed3c7b9a73a82be$export$277d7fa50e12435e('(000) 000-0000', phoneNumber);
    for(let i = originalChars.length; i > 0; i--)if (originalChars[i - 1] !== ' ' && !isNaN(originalChars[i - 1])) originalChars[i - 1] = replacementChars.pop();
    return originalChars.join('');
}
function $8ed3c7b9a73a82be$export$e236fc13b12bbcd4(text) {
    // Strip invisible Unicode formatting characters from PDFs (directional marks, zero-width spaces, etc.)
    const cleanText = text.replace(/[\u200B-\u200F\u202A-\u202E\u2060\uFEFF]/g, '');
    const formattedPhoneNumbers = [];
    for (let match of cleanText.matchAll((0, $09918bacc8c2dda0$export$ed1198d4679e93aa))){
        const [originalFormat, ...groups] = match;
        const parts = groups.slice(0, -1);
        formattedPhoneNumbers.push({
            originalFormat: originalFormat.trim(),
            raw: parts.join('')
        });
    }
    return formattedPhoneNumbers;
}
const $8ed3c7b9a73a82be$var$defaultOptions = {
    ignoreId: false
};
function $8ed3c7b9a73a82be$export$4e26f457d394e36b(el, customOptions) {
    const options = {
        ...$8ed3c7b9a73a82be$var$defaultOptions,
        ...customOptions
    };
    let nodeElem = el;
    if (nodeElem && nodeElem.id && !options.ignoreId) return "//*[@id=\"" + nodeElem.id + "\"]";
    let parts = [];
    while(nodeElem && Node.ELEMENT_NODE === nodeElem.nodeType){
        let nbOfPreviousSiblings = 0;
        let hasNextSiblings = false;
        let sibling = nodeElem.previousSibling;
        while(sibling){
            if (sibling.nodeType !== Node.DOCUMENT_TYPE_NODE && sibling.nodeName === nodeElem.nodeName) nbOfPreviousSiblings++;
            sibling = sibling.previousSibling;
        }
        sibling = nodeElem.nextSibling;
        while(sibling){
            if (sibling.nodeName === nodeElem.nodeName) {
                hasNextSiblings = true;
                break;
            }
            sibling = sibling.nextSibling;
        }
        let prefix = nodeElem.prefix ? nodeElem.prefix + ":" : "";
        let nth = nbOfPreviousSiblings || hasNextSiblings ? "[" + (nbOfPreviousSiblings + 1) + "]" : "";
        parts.push(prefix + nodeElem.localName + nth);
        nodeElem = nodeElem.parentNode;
    }
    return parts.length ? "/" + parts.reverse().join("/") : "";
}



const $09918bacc8c2dda0$export$ed1198d4679e93aa = new RegExp(/(?:(?:\+?([1-9]\d{0,2})\s*(?:[.\-–—]\s*)?)?)?(?:(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))|(?:\(([0-9]{3})\)\s*|([0-9]{3})))(?:\s*(?:[.\-–—]\s*)?(\d)\s*(?:[.\-–—]\s*)?(\d)\s*(?:[.\-–—]\s*)?(\d)(?:\s*(?:[.\-–—]\s*)?(\d))?(?:\s*(?:[.\-–—]\s*)?(\d))?(?:\s*(?:[.\-–—]\s*)?(\d))?(?:\s*(?:[.\-–—]\s*)?(\d))?(?:\s*(?:[.\-–—]\s*)?(\d))?(?:\s*(?:[.\-–—]\s*)?(\d))?|\s*(?:[.\-–—]\s*)?([A-Za-z0-9])\s*(?:[.\-–—]\s*)?([A-Za-z0-9])\s*(?:[.\-–—]\s*)?([A-Za-z0-9])(?:\s*(?:[.\-–—]\s*)?([A-Za-z0-9]))?(?:\s*(?:[.\-–—]\s*)?([A-Za-z0-9]))?(?:\s*(?:[.\-–—]\s*)?([A-Za-z0-9]))?(?:\s*(?:[.\-–—]\s*)?([A-Za-z0-9]))?)(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?(?=[A-Za-z]{0,5}[.\-–—\s]|$)/g);
let $09918bacc8c2dda0$var$changes = [];
const $09918bacc8c2dda0$export$45e8ee9780092531 = ()=>{
    for (const [type, node, value] of $09918bacc8c2dda0$var$changes){
        if (type === 'text') node.nodeValue = value;
        else if (type === 'href') node.setAttribute('href', value);
    }
    $09918bacc8c2dda0$var$changes = [];
};
const $09918bacc8c2dda0$export$60090ea9406766b9 = ()=>{
    return $09918bacc8c2dda0$var$changes.reduce((carry, change)=>{
        if (carry) return true;
        if (!document.body.contains(change[1])) return false;
        if (change[0] === 'href') {
            if (change[1] instanceof HTMLAnchorElement) {
                if (change[1].href !== change[3]) return true;
            }
        } else if (change[1] instanceof Node) {
            if (change[1].nodeValue !== change[3]) return true;
        }
        return false;
    }, false);
};
const $09918bacc8c2dda0$export$328f4521fd6579bd = (node, swaps)=>{
    const pendingEvents = [];
    const replaceTextValue = (text)=>{
        return (0, $8ed3c7b9a73a82be$export$e236fc13b12bbcd4)(text).reduce((result, phoneNumber)=>{
            const target = (0, $8ed3c7b9a73a82be$export$82112e1a17c2a69b)(phoneNumber.raw).toUpperCase();
            const swap = swaps.filter((swap)=>swap.swapTargets.includes(target)).pop();
            if (swap === undefined) return result;
            const replacement = (0, $8ed3c7b9a73a82be$export$277d7fa50e12435e)(phoneNumber.originalFormat, swap.number);
            (0, $5f0936c8b0990a8b$export$1c9f709888824e05)(`swapping ${phoneNumber.raw} -> ${swap.number}`);
            pendingEvents.push(new CustomEvent('800dni.swap', {
                detail: {
                    node: node,
                    replacement: replacement,
                    replacementE164: swap.number,
                    original: phoneNumber.originalFormat,
                    originalE164: target,
                    selector: (0, $8ed3c7b9a73a82be$export$4e26f457d394e36b)(node.parentElement)
                }
            }));
            return result.replace(phoneNumber.originalFormat, replacement);
        }, text);
    };
    const replaceHrefAttribute = (node)=>{
        const href = node.getAttribute('href');
        if (href) {
            node.setAttribute('href', replaceTextValue(decodeURI(href)));
            $09918bacc8c2dda0$var$changes.push([
                'href',
                node,
                href,
                replaceTextValue(decodeURI(href))
            ]);
        }
    };
    if (node instanceof HTMLAnchorElement) replaceHrefAttribute(node);
    else if (node.nodeType === Node.TEXT_NODE) {
        const replacement = replaceTextValue(String(node.nodeValue));
        if (replacement !== node.nodeValue) {
            $09918bacc8c2dda0$var$changes.push([
                'text',
                node,
                String(node.nodeValue),
                replacement
            ]);
            node.nodeValue = replacement;
            if (node.parentElement) replaceHrefAttribute(node.parentElement);
        }
    } else if (node instanceof Element) {
        // Handle parent elements with phone numbers split across child nodes
        const originalText = node.textContent || '';
        const replacedText = replaceTextValue(originalText);
        if (replacedText !== originalText) {
            const originalHTML = node.innerHTML;
            // Create a temporary div with the original HTML (only once)
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = originalHTML;
            // Extract all phone numbers from the original text
            const phoneNumbers = (0, $8ed3c7b9a73a82be$export$e236fc13b12bbcd4)(originalText);
            phoneNumbers.forEach((phoneNumber)=>{
                const target = (0, $8ed3c7b9a73a82be$export$82112e1a17c2a69b)(phoneNumber.raw).toUpperCase();
                const swap = swaps.filter((swap)=>swap.swapTargets.includes(target)).pop();
                if (swap) {
                    const replacement = (0, $8ed3c7b9a73a82be$export$277d7fa50e12435e)(phoneNumber.originalFormat, swap.number);
                    // Find where the phone number appears in the original text
                    const phoneStartIndex = originalText.indexOf(phoneNumber.originalFormat);
                    const phoneEndIndex = phoneStartIndex + phoneNumber.originalFormat.length;
                    // Walk through all text nodes and track position in combined text
                    const walker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT);
                    let textNode;
                    // Collect all text nodes first (since walker state can be affected by modifications)
                    const textNodes = [];
                    while(textNode = walker.nextNode())textNodes.push(textNode);
                    // Now process each text node
                    let combinedPosition = 0;
                    textNodes.forEach((tn)=>{
                        const nodeValue = tn.nodeValue || '';
                        const nodeStart = combinedPosition;
                        const nodeEnd = combinedPosition + nodeValue.length;
                        // Check if this text node overlaps with the phone number
                        if (nodeEnd > phoneStartIndex && nodeStart < phoneEndIndex) {
                            // Calculate which part of this node overlaps with the phone number
                            const overlapStart = Math.max(0, phoneStartIndex - nodeStart);
                            const overlapEnd = Math.min(nodeValue.length, phoneEndIndex - nodeStart);
                            // Extract the parts
                            const before = nodeValue.substring(0, overlapStart);
                            const overlapping = nodeValue.substring(overlapStart, overlapEnd);
                            const after = nodeValue.substring(overlapEnd);
                            // Find the corresponding part in the replacement
                            const phoneOffset = nodeStart + overlapStart - phoneStartIndex;
                            const replacementPart = replacement.substring(phoneOffset, phoneOffset + overlapping.length);
                            tn.nodeValue = before + replacementPart + after;
                        }
                        combinedPosition += nodeValue.length;
                    });
                }
            });
            const newHTML = tempDiv.innerHTML;
            if (newHTML !== originalHTML) {
                node.innerHTML = newHTML;
                $09918bacc8c2dda0$var$changes.push([
                    'text',
                    node,
                    originalHTML,
                    newHTML
                ]);
            }
            if (node.parentElement) replaceHrefAttribute(node.parentElement);
        }
    }
    for (const event of pendingEvents)window.dispatchEvent(event);
};




const $94a83508004090d1$var$cdns = [
    "invocacdn.com",
    "cdn.callrail.com",
    "revenue.io",
    "ksrndkehqnwntyxlhgto.com"
];
class $94a83508004090d1$export$2e2bcd8739ae039 {
    constructor(callTracking, renderer, undoPhoneNumberRenderer, storage, api){
        this.callTracking = callTracking;
        this.renderer = renderer;
        this.undoPhoneNumberRenderer = undoPhoneNumberRenderer;
        this.storage = storage;
        this.api = api;
    //
    }
    static getInstance(callTracking, phoneNumberRenderer, undoPhoneNumberRenderer, storage, api) {
        if (!$94a83508004090d1$export$2e2bcd8739ae039.instance) $94a83508004090d1$export$2e2bcd8739ae039.instance = new $94a83508004090d1$export$2e2bcd8739ae039(callTracking, phoneNumberRenderer, undoPhoneNumberRenderer, storage, api);
        return $94a83508004090d1$export$2e2bcd8739ae039.instance;
    }
    run() {
        if (!this.storage.get('800calltrk.monitors')) this.storage.set('800calltrk.monitors', {
            extraNumbers: [],
            foundConflictingScript: false,
            swapChanged: false
        });
        const stop = (0, $d0b7dfbc17617186$export$ca12be886f5e4fed)(async (node)=>{
            if (this.callTracking.current?.swaps) this.renderer(node, this.callTracking.current.swaps);
        });
        this.callTracking.pending.then((response)=>{
            stop();
            this.undoPhoneNumberRenderer();
            if (response?.isSessionTrackingEnabled) (0, $f666fece0d4e83e8$export$76b46e2f8835d97)();
            if (response?.swaps) (0, $d0b7dfbc17617186$export$ca12be886f5e4fed)(async (node)=>{
                this.renderer(node, response.swaps);
            });
            setTimeout(()=>{
                const previouslyReported = this.storage.get('800cltrk.extraNumbers') || [];
                const potentialSwaps = [
                    ...new Set((0, $d0b7dfbc17617186$export$9e32ceef92e19c15)(document.body).map((n)=>n.nodeValue?.match((0, $d0b7dfbc17617186$export$c75e4443b477ae4))).filter((n)=>!!n).map((n)=>String(n).replace(/\D/g, '')).map((n)=>{
                        if (n.startsWith('1')) n = "+" + n;
                        else if (!n.startsWith("+")) n = "+1" + n;
                        return n;
                    }))
                ].filter((n)=>!previouslyReported.includes(n));
                if (potentialSwaps.length > 0) this.api.reportExtraNumbers(potentialSwaps).then(()=>{
                    this.storage.set('800cltrk.extraNumbers', [
                        ...previouslyReported,
                        ...potentialSwaps
                    ]);
                });
            });
        });
        setTimeout(()=>{
            if (this.storage.get('800cltrk.swapRemoved')) return;
            if ((0, $09918bacc8c2dda0$export$60090ea9406766b9)()) {
                this.api.reportSwapChanged();
                this.storage.set('800cltrk.swapRemoved', true);
            }
        }, 60000);
        setTimeout(()=>{
            if (this.storage.get('800cltrk.conflicting')) return;
            const scripts = document.getElementsByName('script');
            const found = $94a83508004090d1$var$cdns.reduce((carry, cdn)=>{
                let found = false;
                scripts.forEach((script)=>{
                    if (script.src.includes(cdn)) found = true;
                });
                return carry || found;
            }, false);
            if (found) {
                this.api.reportConflictingScript();
                this.storage.set('800cltrk.conflicting', true);
                return;
            }
            // @ts-ignore
            if (window['CTMSourceEVent'] !== undefined || window['_ctm'] !== undefined) {
                this.api.reportConflictingScript();
                this.storage.set('800cltrk.conflicting', true);
                return;
            }
        }, 10000);
        return this;
    }
}








const $c143955347d96110$export$8b437002c2b08d1 = '800cltrk.session';
const $c143955347d96110$var$SESSION_DURATION = 15768000; // one year
const $c143955347d96110$var$SESSION_DURATION_MS = $c143955347d96110$var$SESSION_DURATION * 1000; // one year
const $c143955347d96110$var$SWAP_DURATION_MS = 1800000; // 30 minutes
const $c143955347d96110$var$expireSwaps = (options)=>{
    // SESSION_KEY is cached for one year, and expiry is reset whenever there's activity.
    // but we only want swaps to be cached for up to 30 minutes of inactivity.
    // expiration date timestamp (ms)
    // this should be `last_activity_at + 1 year`
    const expiry = options.storage.getExpiry($c143955347d96110$export$8b437002c2b08d1);
    if (expiry === null) return;
    if (expiry - $c143955347d96110$var$SESSION_DURATION_MS + $c143955347d96110$var$SWAP_DURATION_MS < new Date().getTime()) {
        const data = options.storage.get($c143955347d96110$export$8b437002c2b08d1) || {};
        // this resets the TTL, but that's fine since we only execute this right before refreshing the
        // cached data anyway.
        options.storage.set($c143955347d96110$export$8b437002c2b08d1, {
            ...data,
            swaps: undefined
        }, $c143955347d96110$var$SESSION_DURATION);
    }
};
function $c143955347d96110$export$70f660b32d482235(api, options) {
    $c143955347d96110$var$expireSwaps(options);
    const init = async (sessionId)=>{
        const response = await api.initCallTracking(options.storage.get($c143955347d96110$export$8b437002c2b08d1)?.swaps?.map((swap)=>swap.number) || [], new Date().toISOString(), sessionId, options.pageContext.url, options.pageContext.referrer, options.storage.get($c143955347d96110$export$8b437002c2b08d1)?.lastOverSwappedAt);
        if (response.status !== 200) {
            (0, $5f0936c8b0990a8b$export$a3bc9b8ed74fc)(await response.text());
            throw new Error('Received non-200 response while fetching swaps');
        }
        const payload = await response.json();
        return payload.data;
    };
    const existingSession = options.storage.get($c143955347d96110$export$8b437002c2b08d1);
    const sessionId = existingSession?.sessionId;
    const sessionInitPromise = init(sessionId);
    sessionInitPromise.then((response)=>{
        const cachedResponse = {
            sessionId: response?.sessionId,
            swaps: response.swaps,
            lastOverSwappedAt: options.storage.get($c143955347d96110$export$8b437002c2b08d1)?.lastOverSwappedAt || null
        };
        if (response.lastOverSwappedAt) cachedResponse.lastOverSwappedAt = response.lastOverSwappedAt;
        if (response) options.storage.set($c143955347d96110$export$8b437002c2b08d1, cachedResponse, $c143955347d96110$var$SESSION_DURATION);
        else console.warn('DNI incomplete setup: missing sessionId or swaps from API response.');
    });
    return {
        current: {
            swaps: existingSession?.swaps || []
        },
        pending: sessionInitPromise
    };
}




class $7e114494d61b838c$export$19fffca37ef3e106 {
    static{
        this.internalCache = {};
    }
    constructor(ttl){
        this.ttl = ttl;
    }
    hydrateInternalCache(key) {
        if ($7e114494d61b838c$export$19fffca37ef3e106.internalCache[key] !== undefined) return;
        const result = localStorage.getItem(key);
        if (result === null) {
            $7e114494d61b838c$export$19fffca37ef3e106.internalCache[key] = null;
            return;
        }
        $7e114494d61b838c$export$19fffca37ef3e106.internalCache[key] = JSON.parse(result);
    }
    get(key) {
        this.hydrateInternalCache(key);
        const result = $7e114494d61b838c$export$19fffca37ef3e106.internalCache[key];
        if (result === null || result.data === null) {
            window.dispatchEvent(new CustomEvent('800dni.cache.miss', {
                detail: {
                    key: key
                }
            }));
            return null;
        }
        if (result.expires && result.expires < new Date().getTime()) {
            window.dispatchEvent(new CustomEvent('800dni.cache.prune', {
                detail: {
                    key: key
                }
            }));
            this.set(key, null);
            return null;
        }
        window.dispatchEvent(new CustomEvent('800dni.cache.hit', {
            detail: {
                key: key
            }
        }));
        // hit
        return result.data;
    }
    getExpiry(key) {
        const result = $7e114494d61b838c$export$19fffca37ef3e106.internalCache[key];
        if (result?.expires) return result.expires;
        return null;
    }
    set(key, data, ttl = this.ttl) {
        const expires = ttl === 0 ? 0 : new Date().getTime() + ttl * 1000;
        localStorage.setItem(key, JSON.stringify({
            data: data,
            expires: expires
        }));
        window.dispatchEvent(new CustomEvent('800dni.cache.set', {
            detail: {
                key: key,
                data: data
            }
        }));
    }
    unset(key) {
        localStorage.removeItem(key);
    }
}




var $f4d178fc3dfdbd39$export$2e2bcd8739ae039 = (0, $94a83508004090d1$export$2e2bcd8739ae039);



class $c40af09e17faf3ea$var$EventStorage {
    push(e) {
        this.events.push(e);
    }
    drain() {
        const events = this.events;
        this.events = [];
        return events;
    }
    constructor(){
        this.events = [];
    }
}
const $c40af09e17faf3ea$var$sendEvents = (eventStorage, url, token, sessionId)=>{
    const events = eventStorage.drain();
    if (events.length === 0) return Promise.resolve();
    return new Promise((resolve, reject)=>{
        fetch(`${url}/dniEvents`, {
            method: 'POST',
            body: JSON.stringify({
                token: token,
                events: events,
                sessionId: sessionId
            }),
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        }).then(()=>resolve()).catch((err)=>{
            // noop? We can't report the error.
            console.error(err);
            reject(err);
        });
    });
};
const $c40af09e17faf3ea$export$91ef3232d7381852 = ()=>{
    const eventStorage = new $c40af09e17faf3ea$var$EventStorage();
    const pushDecoratedEvent = (kind)=>(e)=>{
            eventStorage.push({
                ...e.detail,
                date: new Date().toISOString(),
                kind: kind
            });
        };
    window.addEventListener('800dni.asc-datalayer', pushDecoratedEvent('asc_datalayer'));
    window.addEventListener('800dni.asc-event', pushDecoratedEvent('asc_event'));
    window.addEventListener('800dni.ga-session', pushDecoratedEvent('ga_session'));
    window.addEventListener('800dni.ga-client', pushDecoratedEvent('ga_client'));
    window.addEventListener('800dni.page_view', pushDecoratedEvent('page_view'));
    window.addEventListener('800dni.swap', pushDecoratedEvent('swap'));
    window.addEventListener('800dni.error', pushDecoratedEvent('error'));
    return eventStorage;
};
const $c40af09e17faf3ea$export$cde790f843eb5aed = (eventStorage, url, token, sessionId)=>{
    const sendEventsPeriodically = async ()=>{
        await $c40af09e17faf3ea$var$sendEvents(eventStorage, url, token, sessionId);
        setTimeout(sendEventsPeriodically, 1000);
    };
    setTimeout(sendEventsPeriodically, 100);
};


// Parsing for Google Analytics 4 first-party cookies.
//
// We never call Google directly; we just read GA's own cookies so the backend
// can attach the correct client_id / session_id to its Measurement Protocol
// events. There are two cookies we care about:
//
//   _ga              -> the GA4 client id        (format unchanged by Google)
//   _ga_<container>  -> the GA4 session, per container/measurement id
//
// Google ships the session cookie in (at least) two on-the-wire formats and
// can roll a site from one to the other silently:
//
//   GS1 (legacy):  dot-delimited, fixed positions
//                  GS1.1.<sessionId>.<sessionNumber>.<engaged>.<lastHit>.0.0.0
//
//   GS2 (current): "$"-delimited, self-describing labelled fields whose
//                  ORDER IS NOT GUARANTEED and where optional fields may be
//                  absent entirely:
//                  GS2.1.s<sessionId>$o<sessionNumber>$g<engaged>$t<lastHit>$...
//                  ( s = session id, o = session number/count )
//
// Because GS2 fields are labelled and unordered we parse by label, never by
// position, and we treat any future GS<n>(n>=2) as labelled too. This is the
// fix for the "session cookie parser only understands the old format" defect.
const $d5601e1ba6ee3248$export$b33b857ad1d9900e = (message, context)=>{
    window.dispatchEvent(new CustomEvent('800dni.error', {
        detail: {
            message: message,
            context: context
        }
    }));
};


const $f1240072de177995$var$CLIENT_COOKIE_NAME = '_ga';
const $f1240072de177995$var$SESSION_COOKIE_PREFIX = '_ga_';
// GA session ids (a unix timestamp) and session numbers (a counter) are always
// strings of digits. Validating this keeps us from emitting garbage if we ever
// read a malformed or unrelated cookie.
const $f1240072de177995$var$isNumericString = (value)=>/^\d+$/.test(value);
// Something upstream of GA on some sites rewrites `_ga` by prepending a second
// `GA<n>.<n>.` to an intact value (`GA1.1.GA1.1.<id>.<ts>`). Only the outer
// prefixes are stripped; the inner value parses as usual.
const $f1240072de177995$var$DUPLICATED_CLIENT_PREFIX = /^(?:GA\d+\.\d+\.)+(?=GA\d+\.\d+\.)/;
// A UUID where the numeric id belongs is not a GA-issued client id, and there
// is no <id>.<timestamp> pair to recover from it. Pinned to the GA1.1 prefix
// seen in the wild, so a future version that adopts UUIDs is still reported.
const $f1240072de177995$var$UUID_CLIENT_VALUE = /^GA1\.1\.[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;
const $f1240072de177995$export$8eb79843808fc52 = (cookieString)=>{
    if (!cookieString) return [];
    const cookies = [];
    for (const pair of cookieString.split(';')){
        const separator = pair.indexOf('=');
        if (separator === -1) continue;
        const name = pair.slice(0, separator).trim();
        const value = pair.slice(separator + 1).trim();
        if (name) cookies.push({
            name: name,
            value: value
        });
    }
    return cookies;
};
const $f1240072de177995$export$3aae5f44b8227a81 = (value)=>{
    const segments = value.replace($f1240072de177995$var$DUPLICATED_CLIENT_PREFIX, '').split('.');
    // Need at least version.scopeDepth.clientId.clientNumber
    if (segments.length < 4 || !/^GA\d+$/.test(segments[0])) return null;
    // The GA4 client id is exactly the <clientId>.<firstVisitTimestamp> pair —
    // the value gtag('get', id, 'client_id') returns. We read those two known
    // positions rather than "everything after the prefix", so an extra trailing
    // field (should Google ever add one) is ignored instead of corrupting the
    // id. We keep them split for the API, which re-joins them.
    const clientId = segments[2];
    const clientNumber = segments[3];
    if (!$f1240072de177995$var$isNumericString(clientId) || !$f1240072de177995$var$isNumericString(clientNumber)) return null;
    return {
        clientId: clientId,
        clientNumber: clientNumber
    };
};
const $f1240072de177995$export$6f871889cc8f66cb = (value)=>{
    const versionMatch = value.match(/^GS(\d+)\./);
    if (!versionMatch) return null;
    const version = parseInt(versionMatch[1], 10);
    const isLabelled = version >= 2 || value.includes('$');
    const parsed = isLabelled ? $f1240072de177995$var$parseLabelledSession(value) : $f1240072de177995$var$parsePositionalSession(value);
    if (!parsed) return null;
    if (!$f1240072de177995$var$isNumericString(parsed.sessionId) || !$f1240072de177995$var$isNumericString(parsed.sessionNumber)) return null;
    return parsed;
};
/**
 * GS2+: after the `GS<n>.<x>.` prefix the payload is `$`-delimited, labelled,
 * and unordered, e.g. `s1746825440$o14$g0$t1746825440$j60$l0$h0`.
 *   s = session id, o = session number/count.
 */ const $f1240072de177995$var$parseLabelledSession = (value)=>{
    const dotParts = value.split('.');
    if (dotParts.length < 3) return null;
    // Rejoin defensively; the labelled payload itself contains no dots.
    const payload = dotParts.slice(2).join('.');
    const fields = {};
    for (const field of payload.split('$')){
        if (field.length < 2) continue;
        const key = field[0];
        // First occurrence wins; ignore duplicates.
        if (!(key in fields)) fields[key] = field.slice(1);
    }
    if (!('s' in fields) || !('o' in fields)) return null;
    return {
        sessionId: fields['s'],
        sessionNumber: fields['o']
    };
};
/**
 * GS1: `GS1.<x>.<sessionId>.<sessionNumber>.<...>` — fixed positions.
 */ const $f1240072de177995$var$parsePositionalSession = (value)=>{
    const parts = value.split('.');
    if (parts.length < 4) return null;
    return {
        sessionId: parts[2],
        sessionNumber: parts[3]
    };
};
const $f1240072de177995$export$e261cbd61feace99 = (cookies)=>{
    const cookie = cookies.find((c)=>c.name === $f1240072de177995$var$CLIENT_COOKIE_NAME);
    return cookie ? $f1240072de177995$export$3aae5f44b8227a81(cookie.value) : null;
};
const $f1240072de177995$export$c1d45b8e34f404e3 = (cookies)=>{
    const sessions = [];
    for (const { name: name, value: value } of cookies){
        if (name === $f1240072de177995$var$CLIENT_COOKIE_NAME || !name.startsWith($f1240072de177995$var$SESSION_COOKIE_PREFIX)) continue;
        const sessionName = name.slice($f1240072de177995$var$SESSION_COOKIE_PREFIX.length);
        if (!sessionName) continue;
        const parsed = $f1240072de177995$export$6f871889cc8f66cb(value);
        if (parsed) sessions.push({
            sessionName: sessionName,
            ...parsed
        });
    }
    return sessions;
};
const $f1240072de177995$export$89fc5542b76648af = (cookies)=>{
    const unparsable = [];
    for (const { name: name, value: value } of cookies){
        const isClient = name === $f1240072de177995$var$CLIENT_COOKIE_NAME;
        const isSession = !isClient && name.startsWith($f1240072de177995$var$SESSION_COOKIE_PREFIX);
        if (!isClient && !isSession) continue;
        // Only flag values that look like a GA cookie, so we ignore empty or
        // placeholder cookies (and unrelated _ga*-ish names).
        const looksLikeGa = isClient ? /^GA\d/.test(value) : /^GS\d/.test(value);
        if (!looksLikeGa || isClient && $f1240072de177995$var$UUID_CLIENT_VALUE.test(value)) continue;
        const parsed = isClient ? $f1240072de177995$export$3aae5f44b8227a81(value) : $f1240072de177995$export$6f871889cc8f66cb(value);
        if (!parsed) unparsable.push({
            name: name,
            value: value
        });
    }
    return unparsable;
};
// Track which cookies we've already reported this script load. Keyed by cookie
// NAME, not value: an unparsable format can carry a churning timestamp/counter,
// so keying by value would re-report on every 500ms poll and grow this set
// without bound. One report per cookie name per load is enough — the useful
// signal is the volume across many clients, not repeats from one.
const $f1240072de177995$var$reportedUnparsableGaCookies = new Set();
// Cap on the cookie value we ship to the backend, so a pathological cookie
// can't send a huge blob.
const $f1240072de177995$var$MAX_REPORTED_COOKIE_VALUE_LENGTH = 200;
function $f1240072de177995$export$f9ae2e10304f0035(cookies) {
    for (const { name: name, value: value } of $f1240072de177995$export$89fc5542b76648af(cookies)){
        if ($f1240072de177995$var$reportedUnparsableGaCookies.has(name)) continue;
        $f1240072de177995$var$reportedUnparsableGaCookies.add(name);
        const cookieValue = value.length > $f1240072de177995$var$MAX_REPORTED_COOKIE_VALUE_LENGTH ? `${value.slice(0, $f1240072de177995$var$MAX_REPORTED_COOKIE_VALUE_LENGTH)}...` : value;
        (0, $d5601e1ba6ee3248$export$b33b857ad1d9900e)('Unparseable GA cookie', {
            cookieName: name,
            cookieValue: cookieValue
        });
    }
}
function $f1240072de177995$var$initClientTracking() {
    const client = $f1240072de177995$export$e261cbd61feace99($f1240072de177995$export$8eb79843808fc52(document.cookie));
    if (client) {
        window.dispatchEvent(new CustomEvent('800dni.ga-client', {
            detail: {
                clientId: client.clientId,
                clientNumber: client.clientNumber
            }
        }));
        return;
    }
    setTimeout($f1240072de177995$var$initClientTracking, 500);
}
function $f1240072de177995$var$initSessionTracking(foundSessions) {
    const cookies = $f1240072de177995$export$8eb79843808fc52(document.cookie);
    // Covers both `_ga` and `_ga_<container>`; runs on every poll tick but
    // de-dupes internally, so it only reports each new bad cookie once.
    $f1240072de177995$export$f9ae2e10304f0035(cookies);
    const sessions = $f1240072de177995$export$c1d45b8e34f404e3(cookies);
    const newFoundSessions = [];
    for (const session of sessions)if (!foundSessions.includes(session.sessionName)) {
        newFoundSessions.push(session.sessionName);
        window.dispatchEvent(new CustomEvent('800dni.ga-session', {
            detail: {
                sessionName: session.sessionName,
                sessionId: session.sessionId,
                sessionNumber: session.sessionNumber
            }
        }));
    }
    setTimeout(()=>{
        $f1240072de177995$var$initSessionTracking([
            ...foundSessions,
            ...newFoundSessions
        ]);
    }, 500);
}
function $f1240072de177995$export$5b824a20ba9ccd3() {
    $f1240072de177995$var$initClientTracking();
    $f1240072de177995$var$initSessionTracking([]);
}


const $8086f1c1703dac18$export$7c4dafd94c1cbb03 = function(url, token, sessionId) {
    const requestUrl = new URL(`${url}/dniHeartbeat`);
    requestUrl.search = new URLSearchParams({
        token: token,
        session_id: sessionId
    }).toString();
    const requestOptions = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        })
    };
    const beat = ()=>{
        fetch(requestUrl, requestOptions).catch(()=>{
        // Do nothing
        });
    };
    setInterval(beat, 60000);
};


class $01a5382bb4f1a23e$export$bf71da7aebe9ddc1 {
    constructor(url){
        this.url = url;
    }
    initCallTracking(swaps, date, sessionId, landingPage, referrer, lastOverSwappedAt) {
        return fetch(this.url, {
            method: 'POST',
            body: JSON.stringify({
                sessionId: sessionId,
                landingPage: landingPage,
                referrer: referrer,
                date: date,
                swaps: swaps,
                lastOverSwappedAt: lastOverSwappedAt
            }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }
    async reportExtraNumbers(numbers) {
        await fetch(this.url + "/monitorExtraNumbers", {
            method: 'POST',
            body: JSON.stringify({
                numbers: numbers
            }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }
    async reportConflictingScript() {
        await fetch(this.url + "/monitorConflicts", {
            method: 'POST',
            body: JSON.stringify({}),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }
    async reportSwapChanged() {
        await fetch(this.url + "/monitorSwapChanged", {
            method: 'POST',
            body: JSON.stringify({}),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }
}


window._800js ||= {};
window._800testing ||= {};
window._800swaps ||= [];
const $2d081a1fa49e40a2$var$getPageContext = ()=>{
    return {
        url: window._800testing?.url || window.location.href,
        referrer: window._800testing?.referrer || document.referrer,
        title: window._800testing?.title || document.title
    };
};
const $2d081a1fa49e40a2$var$script = document.currentScript;
const $2d081a1fa49e40a2$var$current = $2d081a1fa49e40a2$var$script ? new URL($2d081a1fa49e40a2$var$script.src) : null;
const $2d081a1fa49e40a2$var$token = $2d081a1fa49e40a2$var$current?.searchParams.get('token') || $2d081a1fa49e40a2$var$script?.getAttribute('data-token') || String(undefined);
const $2d081a1fa49e40a2$var$url = ($2d081a1fa49e40a2$var$current?.searchParams.get('backend') || $2d081a1fa49e40a2$var$script?.getAttribute('data-backend') || String(undefined))// remote trailing slash because we need to build different URL paths
.replace(/\/$/, '');
if (!$2d081a1fa49e40a2$var$url) (0, $5f0936c8b0990a8b$export$a3bc9b8ed74fc)('missing url');
if ($2d081a1fa49e40a2$var$url) {
    const storage = new (0, $7e114494d61b838c$export$19fffca37ef3e106)(window._800js.ttl || 3600);
    const pageContext = $2d081a1fa49e40a2$var$getPageContext();
    const api = new (0, $01a5382bb4f1a23e$export$bf71da7aebe9ddc1)(`${$2d081a1fa49e40a2$var$url}/calltrk/${$2d081a1fa49e40a2$var$token}`);
    const callTracking = (0, $c143955347d96110$export$70f660b32d482235)(api, {
        storage: storage,
        apiUrl: `${$2d081a1fa49e40a2$var$url}/calltrk/${$2d081a1fa49e40a2$var$token}`,
        pageContext: pageContext
    });
    (0, $5f0936c8b0990a8b$export$a80b3bd66acc52ff)('booting', window._800js);
    // to check that we are swapping with selenium testing, must be set before the app is run
    // or we'll swap before we assign the listener.
    window.addEventListener('800dni.swap', function(e) {
        if (!window._800swaps.includes(e.detail.replacementE164)) window._800swaps.push(e.detail.replacementE164);
    });
    const eventStorage = (0, $c40af09e17faf3ea$export$91ef3232d7381852)();
    const app = (0, $f4d178fc3dfdbd39$export$2e2bcd8739ae039).getInstance(callTracking, (0, $09918bacc8c2dda0$export$328f4521fd6579bd), (0, $09918bacc8c2dda0$export$45e8ee9780092531), storage, api).run();
    (0, $5f0936c8b0990a8b$export$1c9f709888824e05)('started app');
    if ((0, $5f0936c8b0990a8b$export$931813d4b9c88e2a)()) Object.assign(window._800js, {
        app: app
    });
    (async ()=>{
        const swapResponse = await callTracking.pending;
        if (!swapResponse?.sessionId || !swapResponse?.isSessionTrackingEnabled) return;
        const sessionId = swapResponse?.sessionId;
        (0, $5f0936c8b0990a8b$export$1c9f709888824e05)({
            sessionId: sessionId
        });
        (0, $c40af09e17faf3ea$export$cde790f843eb5aed)(eventStorage, $2d081a1fa49e40a2$var$url, $2d081a1fa49e40a2$var$token, sessionId);
        (0, $8086f1c1703dac18$export$7c4dafd94c1cbb03)($2d081a1fa49e40a2$var$url, $2d081a1fa49e40a2$var$token, sessionId);
        (0, $f1240072de177995$export$5b824a20ba9ccd3)();
        (0, $a6af0f4fc1a7d864$export$1ef0a386b5db328d)();
        window.dispatchEvent(new CustomEvent('800dni.page_view', {
            detail: {
                url: pageContext.url,
                referrer: pageContext.referrer || null,
                title: pageContext.title
            }
        }));
    })();
}

})();
//# sourceMappingURL=index.js.map
